export const getReplaysInRange = ({ start, end }, replays) =>
  replays.filter(replay => replay.start >= start && replay.end <= end);
export const getWidthPercent = ({ start, end }, duration) =>
  ((end - start) * 100) / duration;
export const getSkippedWidthPercent = (prev, cur, duration) =>
  getWidthPercent({ start: prev.end, end: cur.start }, duration);
export const toPercentOfDuration = (ts, videoDuration) =>
  (ts * 100) / videoDuration + '%';

export const getComputedSegments = ({
  plays,
  replays,
  skips,
  duration = 0,
}) => {
  if (!plays) {
    return [];
  }

  const withType = (items, type) =>
    items.map(({ start, end }) => ({ start, end, type }));

  const segments = [
    ...withType(plays, 'played'),
    ...withType(skips, 'skipped'),
  ].sort((a, b) => a.start - b.start);

  return segments.map(el => {
    const width = getWidthPercent(el, duration);
    const replayBlocks = [];
    const segmentDuration = el.end - el.start;
    const segmentStart = el.start;
    const replaysInRange = getReplaysInRange(el, replays).sort(
      (a, b) => a.start - b.start
    );

    for (let i = 0; i <= replaysInRange.length; i++) {
      let type = 'replayed';
      const prev = replaysInRange[i - 1] || {
        start: segmentStart,
        end: segmentStart,
      };
      const curr = replaysInRange[i] || {
        start: prev.end,
        end: segmentDuration,
      };

      if (prev) {
        const width = getSkippedWidthPercent(prev, curr, segmentDuration);

        width && replayBlocks.push({ width, type: 'filler' });
      }

      const width = getWidthPercent(curr, segmentDuration);

      if (!replaysInRange[i]) {
        if (curr.start > curr.end) {
          continue;
        }

        type = 'filler';
      }

      replayBlocks.push({ width, type, start: curr.start });
    }

    return { width, type: el.type, start: el.start, replayBlocks };
  });
};

export const toPercent = num => (isNaN(num) ? 'n/a' : `${Math.round(num)}%`);
export const percentToColor = percent => {
  const num = parseInt(percent, 10);

  if (isNaN(num)) {
    return 'body';
  }

  return num <= 25 ? 'red' : num < 60 ? 'yellow' : 'green';
};
